import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { HeroUIProvider } from "@heroui/react";
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    // <StrictMode>
    <HeroUIProvider>
        <App />
    </HeroUIProvider>
    // </StrictMode>
);